import { isFailedAndReport } from '@/api/helper'
import { withDialogLoading } from '@/utils/task'
import { Vue, Component, Prop, Ref } from 'vue-property-decorator'
import QRCode from 'qrcode2'

@Component({
    name: 'BindNotify'
})
export class BindNotifyImpl extends Vue {
    onConfirm() {
        this.$emit('close')
    }

    onCancel() {
        this.$emit('close')
    }
    onClose() {
        this.$emit('close')
    }

    @Ref()
    qrCodeHolderRef: HTMLDivElement

    mounted() {
        const buildTask = async () => {
            const res = await this.$api.system.userGetWeixinNoticeUrl()
            if (isFailedAndReport(this, res)) {
                return
            }
            const qrcode = new QRCode(this.qrCodeHolderRef, {
                text: res.data,
                width: 160,
                height: 160,
                colorDark: "#000000",
                colorLight: "#ffffff",
                correctLevel: QRCode.CorrectLevel.H
            })
        }
        withDialogLoading(this, buildTask())
    }
}
